import './vendors/polyfills';
import axios from 'axios';
import { loadProgressBar } from 'axios-progress-bar';
import ReactDOM from 'react-dom';
import App from './App';
import { bootIntercom } from './Utils/Intercom';
import { initAnalytics } from './Utils/analytics';
import { setupDataDog } from './Utils/setupDataDog';
import { GET_USER_INFO } from './constants/endpoints';
import { makeAPICall } from './queries/utils';
import { authStore } from './stores/authStore';
import {
  authenticateUser,
  clearLocalStorage,
  initializeIntercomForUser,
} from './Utils/session';
import { datadogLogs } from '@datadog/browser-logs';
import mobileStore from './stores/mobileAppStore';

(async function renderApp() {
  if (process.env.REACT_APP_IS_MOBILE_DEV_MODE) {
    const searchParams = new URLSearchParams(window.location.search);
    const jwtToken = decodeURIComponent(
      searchParams.get('mobileAuthToken') || '',
    );
    if (jwtToken) {
      mobileStore.setState({ jwtToken });
    }
  }

  loadProgressBar({ showSpinner: false }, axios);

  setupDataDog();

  initAnalytics();

  try {
    /**
     * Note: these are paths where the frontend would request the backend
     * with tokens from the SSO/SAML providers that'd set the cookie,
     * so we can't check if a user's logged in yet.
     *
     * We also shouldn't be checking in case of the template preview URLs
     **/
    if (
      !(
        window.location.pathname.startsWith('/auth/saml') ||
        window.location.pathname.match(/\/signin\/authorize/g) ||
        window.location.pathname.startsWith('/template/')
      )
    ) {
      try {
        const res = await makeAPICall(GET_USER_INFO);
        authenticateUser(res);
        initializeIntercomForUser(res.data.data);
      } catch (err: unknown) {
        datadogLogs.logger.error('Error while logging in', err as object);
        authStore.getState().setAuthStoreStateForAuthenticationError(err);
      }
    }
  } catch {
    clearLocalStorage();
    bootIntercom();
  } finally {
    ReactDOM.render(<App />, document.getElementById('root'));
  }
})();
